module.exports = __webpack_public_path__ + "img/heart.79efc68d.svg";